// EmpleadoSidebar.jsx
import { NavLink } from "react-router-dom";
import { Fingerprint, LogOut, User, X, AlertCircle } from "lucide-react";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { BarChart2 } from "lucide-react";

const menuItems = [
  // { path: "/empleados/dashboard", label: "Dashboard", icon: <BarChart2 size={20} /> },
  { path: "/empleados/perfil", label: "Editar perfil", icon: <User size={20} /> },
  { path: "/empleados/fichar", label: "Fichar", icon: <Fingerprint size={20} /> },
  { path: "/empleados/incidencias", label: "Mis incidencias", icon: <AlertCircle size={20} /> }, // <-- NUEVO
];

export default function EmpleadoSidebar({ className = "", onClose }) {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    if (onClose) onClose();
    navigate("/login");
  };

  return (
    <aside
      className={`shadow h-100 d-flex flex-column ${className}`}
      style={{ width: "250px", backgroundColor: "#FFF8F0", transition: "transform 0.3s" }}
    >
      {/* Header */}
      <div
        className="d-flex align-items-center justify-content-between px-3 py-2"
        style={{ height: "64px", borderBottom: "2px solid #FF7A00" }}
      >
        <NavLink to="/" className="d-flex align-items-center text-decoration-none">
          {/* Logo SVG */}
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#FF7A00" className="me-2" viewBox="0 0 16 16">
            <path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z" />
            <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z" />
          </svg>
          <span className="fw-bold" style={{ color: "#FF7A00" }}>Turnora</span>
        </NavLink>

        {onClose && (
          <button className="btn d-md-none text-secondary" onClick={onClose}>
            <X size={24} />
          </button>
        )}
      </div>

      {/* Menú */}
      <nav className="flex-grow-1 overflow-auto px-2 py-3">
        <ul className="list-unstyled mb-0">
          {menuItems.map(item => (
            <li key={item.path} className="mb-2">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `d-flex align-items-center w-100 px-3 py-2 rounded text-decoration-none ${
                    isActive ? "text-white" : "text-dark"
                  }`
                }
                style={({ isActive }) => ({
                  backgroundColor: isActive ? "#FF7A00" : "transparent",
                  transition: "all 0.2s",
                })}
                onMouseEnter={e => {
                  if (!e.currentTarget.style.backgroundColor || e.currentTarget.style.backgroundColor === "transparent") {
                    e.currentTarget.style.backgroundColor = "#FFE5CC"; // hover suave
                  }
                }}
                onMouseLeave={e => {
                  if (e.currentTarget.style.backgroundColor === "rgb(255, 229, 204)") {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }
                }}
              >
                {item.icon}
                <span className="ms-3">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer Logout */}
      <div className="px-3 py-3 border-top" style={{ borderTopColor: "#FF7A00" }}>
        <button
          className="d-flex align-items-center w-100 px-3 py-2"
          style={{
            backgroundColor: "#FFF8F0",
            color: "#FF7A00",
            border: "1px solid #FF7A00",
            borderRadius: "0.375rem",
            transition: "all 0.2s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = "#FF7A00";
            e.currentTarget.style.color = "#fff";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = "#FFF8F0";
            e.currentTarget.style.color = "#FF7A00";
          }}
          onClick={handleLogout}
        >
          <LogOut size={20} />
          <span className="ms-3">Cerrar sesión</span>
        </button>
        <span style={{color: "white",fontSize: "11px"}}>Versión 0.1</span>
      </div>
    </aside>
  );
}
